<template>
  <v-app-bar
    :clipped-left="$vuetify.breakpoint.lgAndUp"
    app
    color="primary"
    dark
  >
    <v-progress-linear
      :active="isAppLoading"
      :indeterminate="true"
      absolute
      :top="true"
      color="accent"
    ></v-progress-linear>

    <v-toolbar-title style="max-width: 300px">
      <v-app-bar-nav-icon @click.stop="toggleDrawer" />
          <span class="hidden-sm-and-down" v-if="currentUser">{{ currentUser.company }}</span>
    </v-toolbar-title>
    <v-spacer />

    <v-card class="d-inline-flex pa-2" width="250px" flat color="transparent">
      <v-select
        :items="centerList"
        v-model="selectedCenter"
        menu-props="auto"
        label="Location"
        hide-details
        return-object
        item-text="name"
        item-value="id"
        @change="changeCenter"
        :prepend-icon=" $vuetify.breakpoint.smAndDown ? '':'mdi-office-building-marker-outline'"
      ></v-select>
    </v-card>
    <v-menu v-if="modules && modules.length > 0" offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn tile large icon v-bind="attrs" v-on="on">
          <v-icon>mdi-dots-grid</v-icon>
        </v-btn>
      </template>
      <v-card class="mx-auto" max-width="400" width="300" tile>
        <v-card-text>
        <v-row>
          <v-col v-for="module in modules" :key="module.id" style="text-align: center;" cols="6">
            <v-hover v-slot="{ hover }">
              <v-sheet @click="toApp(module)" :elevation="hover ? 16 : 0"
                  :class="{ 'on-hover': hover }">
              <v-icon size="50" :color="module.color"> {{module.icon}} </v-icon><br/>
              {{module.name}}
              </v-sheet>
            </v-hover>
          </v-col>
        </v-row>
        </v-card-text>
      </v-card>
    </v-menu>

    <v-btn data-cy="login" to="/login" v-if="!isLoggedIn" icon title="Login">
      <v-icon>mdi-login</v-icon>
    </v-btn>
    <div v-if="currentUser" class="text-center">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="ma-0" tile large icon v-bind="attrs" v-on="on">
            <v-icon>mdi-shield-account</v-icon>
          </v-btn>
        </template>

        <v-card class="mx-auto" max-width="400" width="200" tile>
          <v-list dense>
            <v-list-item-group v-model="menuItem" color="primary">
              <v-list-item disabled>
                <v-list-item-title>
                  {{ currentUser.firstName }} {{ currentUser.lastName }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                :to="item.link"
                v-for="(item, i) in userMenu"
                :key="i"
              >
                <v-list-item-icon class="mr-2">
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="logout">
                <v-list-item-icon class="mr-2">
                  <v-icon>mdi-logout</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Logout</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-menu>
    </div>
  </v-app-bar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { parseDomain } from "parse-domain";


export default {
  data: () => ({
    selectedCenter: null,
    centerList: [],
    drawer: null,
    menuItem: 1,
    userMenu: [
      // {
      //   text: "My Home",
      //   link: "/secure/myhome",
      //   icon: "mdi-account",
      // },
    ],
    modules: []
  }),
  computed: {
    ...mapGetters(["isLoggedIn", "currentUser", "isAppLoading", "globalCenter"]),
  },
  mounted(){
    if(!this.currentUser)
      return;

    this.initCenters()
      .then( (centers) => {
        this.centerList = centers;
        if(this.centerList && this.centerList.length > 1){
          this.centerList.unshift({id: null, name: 'All Locations', accountId: this.centerList[0].accountId})
        }
        this.setMyCenters(centers);

        this.selectedCenter = this.globalCenter;
        if(centers && centers.length > 0){
          const existIndex = centers.findIndex(c => this.selectedCenter && c.id == this.selectedCenter.id);
          if(!existIndex || existIndex < 0){
            this.selectedCenter = centers[0];
            this.setCenter(this.selectedCenter);
          }
        }
      })
      .finally( () => {
        this.$emit('load', this.selectedCenter)
      })

    this.initModules()
      .then( (modules) => {
        if(modules){
          this.modules = modules.filter(m => m.path !== 'control')
        }
      })
  },
  methods: {
    ...mapActions(["toggleDrawer", "hideDrawer", "processLogout", "setCenter", "setMyCenters"]),
    logout() {
      this.$axios.post("gaa-user/signout").then(() => {
        this.processLogout();
        delete this.$axios.defaults.headers.common["Authorization"];
        this.$router.push({ name: "Login" });
      });
    },
    changeCenter(){
      this.setCenter(this.selectedCenter);
      window.location.reload();
    },
    async initCenters(){
      return await this.$axios.get('/center/get-my-centers')
        .then( (resp) => {
          const centers = resp.data;

          centers.sort((c1, c2) => (c1.name > c2.name) ? 1 : -1)
          return centers;
        })
    },
    async initModules(){
      return await this.$axios.get('/user/module', { params: {user_id: this.currentUser.uId }})
        .then( (resp) => {
          return resp.data;
        })
    },
    toApp(app){
      if(process.env.NODE_ENV != 'development'){
        const parseResult = parseDomain(window.location.hostname);
        const { domain, topLevelDomains } = parseResult;
        const topLevel = topLevelDomains.join(".");

        const moduleUrl = `https://${app.path}.${domain}.${topLevel}`;
        window.location.href = moduleUrl;
      }
    }
  },
};
</script>

<style>
</style>